import {
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { ErrorMessage, Form, Formik } from "formik";
import React, { useState } from "react";
import Images from "../../assets";
import { useAppDispatch, useAppSelector } from "../../assets/hooks";
import { createUser } from "../../services";
import * as Yup from "yup";
import "react-phone-input-2/lib/style.css";
import ReactPhoneInput from "react-phone-input-2";
import { secondaryButton } from "../../components/styles/customStyles";
import { closePopup, setPopup } from "../../store/slices/popupSlice";

const SignUp = () => {
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);
  const [phone, setPhone] = useState({
    countryCode: "",
    number: "",
  });

  const initValues = {
    firstName: "",
    lastName: "",
    email: "",
    phone: {
      number: "",
      countryCode: ""
    },
    isPlanningToTakeLanguageTest: "",
    isPlanningToTakeAcademicTest: "",
  };

  const signInSchema: Yup.ObjectSchema<any> = Yup.object().shape({
    firstName: Yup.string()
      .required("Required")
      .matches(/^[a-zA-Z\s]*$/, "Name should only contain letters and spaces"),
    lastName: Yup.string()
      .required("Required")
      .matches(/^[a-zA-Z\s]*$/, "Name should only contain letters "),
    email: Yup.string()
      .matches(
        /([a-z0-9]+)([{1}])?([a-zA-Z0-9]+)([a-zA-Z0-9]+)([a-z]+)/g,
        "Enter Email Id"
      )
      .required("Enter Email ID")
      .max(40, "Email ID must be at most 40 characters"),
    phone: Yup.object().shape({
      countryCode: Yup.string()
        .required("Country code is required"),
      // .matches(/^\+\d+$/, "Invalid country code"),
      number: Yup.string()
        .required("Phone number is required")
        .matches(/^\d+$/, "Phone number must be numeric"),
    }),
    // isPlanningToTakeLanguageTest:
  });

  const handlePhoneChange = (value: string, data: any, setFieldValue: any) => {
    const dialCode = data?.dialCode || "";
    const enteredCountryCode = dialCode.trim();
    if (value.startsWith(enteredCountryCode)) {
      setPhone({
        countryCode: "+" + enteredCountryCode,
        number: value.slice(enteredCountryCode.length).trim()
      });
      setFieldValue('phone.countryCode', "+" + enteredCountryCode);
      setFieldValue('phone.number', value.slice(enteredCountryCode.length).trim());

    } else {
      const codeSplit = "+" + value.split(dialCode);
      const enteredPhoneNumber = codeSplit.length > 1 ? codeSplit[1].trim() : "";
      setPhone({
        countryCode: enteredCountryCode,
        number: enteredPhoneNumber
      });
      setFieldValue('phone.countryCode', "+" + enteredCountryCode);
      setFieldValue('phone.number', enteredPhoneNumber);
    }
  };

  const onSubmitForm = async (values: any) => {
    setLoading(true)
    let data = {
      firstName: values.firstName,
      lastName: values.lastName,
      email: values.email,
      phone: phone,
      isPlanningToTakeLanguageTest: values.isPlanningToTakeLanguageTest==="Yes"?true:false,
      isPlanningToTakeAcademicTest: values.isPlanningToTakeAcademicTest==="Yes"?true:false
      // language:values.language,
    }
    console.log(values)
    const response = await createUser(data);
    if (response.data.success) {
      setLoading(false)
      dispatch(closePopup())

    } else {
      // console.log("error");
      setLoading(false)

    }
  };

  return (
    <Box sx={{ height: "100%" }}>
      <Grid container sx={{ height: "100%" }}>
        <Grid item xs={12} sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
          <Typography fontWeight="600">Create User</Typography>
          <Box sx={{}}>
            <Formik
              initialValues={initValues}
              validationSchema={signInSchema}
              onSubmit={(values: any) => onSubmitForm(values)}
              enableReinitialize={true}
            >
              {({ errors, values, handleChange, touched, setFieldValue }) => {
                // console.log(errors)

                return (
                  <Form>
                    <Grid container spacing={2} sx={{ mt: 2, overflow: "auto" }} >
                      <Grid item xs={12} md={6}>
                        <TextField
                          id="firstName"
                          name="firstName"
                          type="text"
                          size="small"
                          placeholder="First name *"
                          value={values.firstName}
                          onChange={handleChange}
                          fullWidth
                          label="First name *"
                          error={touched.firstName && Boolean(errors.firstName)}
                        />
                        <div style={{ color: "#d32f2f", fontSize: "12px" }}>
                          <ErrorMessage name="firstName" component="div" />
                        </div>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <TextField
                          id="lastName"
                          name="lastName"
                          type="text"
                          size="small"
                          label="Last name *"

                          placeholder="Last name *"
                          value={values.lastName}
                          onChange={handleChange}
                          fullWidth
                          error={touched.lastName && Boolean(errors.lastName)}
                        />
                        <div style={{ color: "#d32f2f", fontSize: "12px" }}>
                          <ErrorMessage name="lastName" component="div" />
                        </div>
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          id="email"
                          name="email"
                          type="email"
                          placeholder="Email *"
                          label="Email *"

                          value={values.email}
                          onChange={handleChange}
                          fullWidth
                          error={touched.email && Boolean(errors.email)}
                          size="small"
                        />
                        <div style={{ color: "#d32f2f", fontSize: "12px" }}>
                          <ErrorMessage name="email" component="div" />
                        </div>
                      </Grid>


                      <Grid item xs={12}>
                        <FormControl sx={{ width: "100%" }}>
                          <InputLabel id="expertiseCountry-label">Is Planning To Take AcademicTest ?</InputLabel>
                          <Select
                            id="isPlanningToTakeAcademicTest"
                            size="small"
                            name="isPlanningToTakeAcademicTest"
                            value={values.isPlanningToTakeAcademicTest}
                            onChange={handleChange}
                            fullWidth
                            labelId="isPlanningToTakeAcademicTest-label"  // Connect the label to the select
                            input={<OutlinedInput label="Is Planning To Take AcademicTest ?" />}  // Attach label to OutlinedInput

                            sx={{
                              padding: "4px 8px",
                            }}
                          >
                            <MenuItem
                              disabled
                              value=""
                              sx={{
                                "& .MuiTypography-root": {
                                  fontSize: "14px !important",
                                },
                              }}
                            >
                              Is planning to take Language Test?
                            </MenuItem>

                            {["Yes", "No"].map((name) => (
                              <MenuItem
                                key={name}
                                value={name}
                                sx={{
                                  "& .MuiTypography-root": {
                                    fontSize: "14px !important",
                                  },
                                  "& .MuiSvgIcon-root ": {
                                    fontSize: "1rem",
                                  },
                                  whiteSpace: "normal",
                                }}
                              >
                                {name}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>

                      <Grid item xs={12}>
                        <FormControl sx={{ width: "100%" }}>
                          <InputLabel id="expertiseCountry-label">Is Planning To Take LanguageTest ?</InputLabel>
                          <Select
                            id="isPlanningToTakeLanguageTest"
                            size="small"
                            name="isPlanningToTakeLanguageTest"
                            value={values.isPlanningToTakeLanguageTest}
                            onChange={handleChange}
                            fullWidth
                            labelId="isPlanningToTakeLanguageTest-label"  // Connect the label to the select
                            input={<OutlinedInput label="Is Planning To Take LanguageTest ?" />}  // Attach label to OutlinedInput

                            sx={{
                              padding: "4px 8px",
                            }}
                          >
                            <MenuItem
                              disabled
                              value=""
                              sx={{
                                "& .MuiTypography-root": {
                                  fontSize: "14px !important",
                                },
                              }}
                            >
                              Is planning to take Language Test?
                            </MenuItem>

                            {["Yes", "No"].map((name) => (
                              <MenuItem
                                key={name}
                                value={name}
                                sx={{
                                  "& .MuiTypography-root": {
                                    fontSize: "14px !important",
                                  },
                                  "& .MuiSvgIcon-root ": {
                                    fontSize: "1rem",
                                  },
                                  whiteSpace: "normal",
                                }}
                              >
                                {name}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>

                      <Grid item xs={12}>
                        <ReactPhoneInput
                          value={`${phone.countryCode} ${phone.number}`}
                          onChange={(value, data) => handlePhoneChange(value, data, setFieldValue)}
                          country="in"
                        />
                        {touched.phone?.countryCode && errors.phone?.countryCode && (
                          <Typography variant="caption" color="error" sx={{ mr: 2 }}>
                            {errors.phone.countryCode}
                          </Typography>
                        )}
                        {touched.phone?.number && errors.phone?.number && (
                          <Typography variant="caption" color="error">
                            {errors.phone.number}
                          </Typography>
                        )}
                      </Grid>

                    </Grid>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sx={{ display: "flex", justifyContent: "center", mt: 1 }}>
                        <Button
                          sx={[secondaryButton, { width: "150px" }]}
                          type="submit"
                        >
                          {loading ? (
                            <img
                              src={Images.standardLoader}
                              alt="load"
                              style={{
                                width: "20px",
                                height: "20px",
                                padding: "5px",
                              }}
                            />
                          ) : (
                            "Register"
                          )}

                        </Button>
                      </Grid>
                    </Grid>
                  </Form>
                )
              }

              }
            </Formik>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default SignUp;
